import { ExtraPackagesData } from '../../../../types/client';
import { MingcutePackageLine } from '../../../../assets/icons/Icons';
import { useDispatch } from 'react-redux';
import { Default, removePackage, setSelectedPackageView, updatePackage } from '../../../../features/client/clientSlice';
import { setTypeOfAdditionalModal, setTypeOfThirdModal } from '../../../../features/modal/modalSlice';

interface ClientModalPackageProps {
    pkg: ExtraPackagesData
    isSaveNewPackages?: boolean;
    typeOfAction?: 'newClient' | 'update'
    hasReduxPackages?: boolean;
    type: 'api' | 'redux';
}

export default function ClientModalPackage({ type, typeOfAction, pkg, hasReduxPackages }: ClientModalPackageProps) {

    const dispatch = useDispatch()
    const isDisabledInput = hasReduxPackages && type === 'api'

    const selectedPackageToView :Default = {
        id: pkg.packageId,
        name: pkg.packageName,
    }

    const handleViewPackage = ( selectedPackage: Default, isDefaultPackage?: boolean ) => {
        if(!selectedPackage.id) return;
        if(!selectedPackage.name) return;
    
        dispatch(setSelectedPackageView({
            id: selectedPackage.id,
            name: selectedPackage.name,
        }))
    
        if (typeOfAction === 'newClient' && isDefaultPackage) {
            dispatch(setTypeOfAdditionalModal('viewDefaultPackage'));
            return;
        }

        dispatch(setTypeOfThirdModal('viewPackageSelected'));
    }

    return (
        <div className="flex flex-col rounded p-2 cursor-pointer transition-colors bg-white ring-1 ring-cbColor border-t-8 border-cbColor space-y-1.5 ">
            <div className='space-y-1'>
                <div className='flex justify-between flex-row-reverse items-center'>
                    <MingcutePackageLine height={25} width={25}/>                                       
                    <p className='text-[13px] font-medium truncate'>
                        {pkg.packageName}
                    </p>
                </div>
                <div className='flex justify-between'>
                    <p className='text-[13px]'>{'Amount:'}</p>
                    <p className='text-[13px]'>
                        {pkg.isDefaultPackage ? (
                            '0'
                        ) : (
                            pkg.totalValue?.toLocaleString()
                        )}
                    </p>
                </div>
                <div className='flex justify-between'>
                    <p className='text-[13px]'>{'Cups:'}</p>
                    <p className='text-[13px]'>
                        {`${pkg.remainingQty}/${pkg.quantity}`}
                    </p>
                </div>
            </div>
            <hr className="h-px my-2 bg-gray-200 border-1" />
                <div className='flex flex-col space-y-1'>
                <div className='flex flex-col space-y-1'>
                    <p className='text-[13px] font-medium'>Start</p>
                    <input 
                        className='text-[13px] border border-gray-300 px-2 py-1 shadow-sm rounded' 
                        type="date"
                        value={pkg.startDate}
                        onChange={(e) => { dispatch(updatePackage({ packageId: pkg.packageId, field: 'startDate', value: e.target.value}))}}
                        disabled={isDisabledInput || pkg.isDefaultPackage}
                    />
                    <input 
                        className='text-[13px] border border-gray-300 px-2 py-1 shadow-sm rounded' 
                        type="time" 
                        value={pkg.startTime}
                        onChange={(e) => dispatch(updatePackage({ packageId: pkg.packageId, field: 'startTime', value: e.target.value}))}
                        disabled={isDisabledInput || pkg.isDefaultPackage}
                    />
                </div>
                <div className='flex flex-col space-y-1'>
                    <p className='text-[13px] font-medium'>End</p>
                    <input 
                        className='text-[13px] border border-gray-300 px-2 py-1 shadow-sm rounded' 
                        type="date" 
                        value={pkg.endDate}
                        onChange={(e) => dispatch(updatePackage({ packageId: pkg.packageId, field: 'endDate', value: e.target.value}))}
                        disabled={isDisabledInput || pkg.isDefaultPackage}
                    />
                    <input 
                        className='text-[13px] border border-gray-300 px-2 py-1 shadow-sm rounded' type="time" 
                        value={pkg.endTime}
                        onChange={(e) => dispatch(updatePackage({ packageId: pkg.packageId, field: 'endTime', value: e.target.value}))}
                        disabled={isDisabledInput || pkg.isDefaultPackage}
                    />
                </div>
            </div>
            <div className={`w-full grid gap-1 ${pkg.isDefaultPackage ? 'grid-cols-1' : 'grid-cols-2'}`}>
                {/* {type === 'api' && (
                    pkg.isDefaultPackage ? (
                        <button 
                            className='py-1.5 bg-cbColor text-white text-[12px] rounded'
                            onClick={() => handleViewPackage(selectedPackageToView, pkg.isDefaultPackage)}
                        >
                            View
                        </button>
                    ) : (
                        isUpdate ? (
                            <>
                                <button 
                                    className='py-1.5 bg-gray-300 text-gray-900 text-[12px] rounded'
                                    onClick={() => setIsUpdate(false)}
                                >
                                    Cancel
                                </button>
                                <button 
                                    onClick={() => handleSavePackage()}
                                    className='py-1.5 bg-cbColor text-white text-[12px] rounded'
                                >
                                    Save
                                </button>
                            </>
                        ) : (
                            <>
                                <button 
                                    className='py-1.5 bg-cbColor text-white text-[12px] rounded'
                                    onClick={() => handleViewPackage(selectedPackageToView, pkg.isDefaultPackage)}
                                >
                                    View
                                </button>
                                <button 
                                    onClick={() => handleUpdatePackage()}
                                    className='py-1.5 bg-cbColor text-white text-[12px] rounded'
                                >
                                    Update
                                </button>
                            </>
                        )
                    )
                )} */}
                { type === 'redux' && (
                    <>
                        <button 
                            className='py-1.5 bg-cbColor text-white text-[12px] rounded'
                            onClick={() => handleViewPackage(selectedPackageToView, pkg.isDefaultPackage)}
                        >
                            View
                        </button>
                        <button 
                            onClick={() => dispatch(removePackage(pkg.packageId))} 
                            className='py-1.5 bg-cbColor text-white text-[12px] rounded'
                        >
                            Remove
                        </button>
                    </>
                )}
            </div>
        </div>
    )
}
